import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ApplicationTemplate from '@dashboardComponents/ApplicationTemplate/ApplicationTemplate';

import {
  Refresh as RefreshIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

import { selectUserRoles, selectUserPermissions } from '@store/auth';

import ForumIcon from '@mui/icons-material/Forum';
import LegacyMaintenanceScheduleList from './pages/maintenance-schedule/LegacyMaintenanceScheduleList';
import LegacyMaintenanceScheduleForm from './pages/maintenance-schedule/LegacyMaintenanceScheduleForm';
import LegacyContextualMessagesList from './pages/legacy-contextual-messages/ContextualMessagesList';
import LegacyContextualMessagesForm from './pages/legacy-contextual-messages/ContextualMessagesForm';
import LegacyConfigurationList from './pages/configuration-module/ConfigModuleList';
import LegacyConfigurationForm from './pages/configuration-module/ConfigModuleForm';
import LegacyCacheReloadList from './pages/cache-reload/CacheReloadList';

import {
  MAINTENANCE_SCHEDULE_LIST_ROUTE,
  LEGACY_CONTEXTUAL_MESSAGES_LIST_ROUTE,
  LEGACY_CONFIGURATION_MODULE_LIST_ROUTE,
  LEGACY_CACHE_RELOAD_LIST_ROUTE,
} from './legacy-payment-options.breadcrumbs';

import { ROLES } from '../../app/App.constants';

import { getFirstRoute } from '../../utils/utils';

const tabs = [
  {
    title: 'Contextual Messages',
    icon: <ForumIcon />,
    disabled: false,
    path: LEGACY_CONTEXTUAL_MESSAGES_LIST_ROUTE,
    roles: [
      ROLES.ROLE_LEGACY_CONTEXTUAL_MESSAGES_VIEW,
      ROLES.ROLE_LEGACY_CONTEXTUAL_MESSAGES_EDIT,
    ],
  },
  {
    title: 'Maintenance Schedule',
    icon: <SettingsIcon />,
    path: MAINTENANCE_SCHEDULE_LIST_ROUTE,
    roles: [
      ROLES.ROLE_LEGACY_ADMIN,
      ROLES.ROLE_LEGACY_MAINTENANCE_SCHEDULE_VIEW,
      ROLES.ROLE_LEGACY_MAINTENANCE_SCHEDULE_EDIT,
    ],
  },
  {
    title: 'Configuration Module',
    icon: <SettingsIcon />,
    path: LEGACY_CONFIGURATION_MODULE_LIST_ROUTE,
    roles: [
      ROLES.ROLE_LEGACY_ADMIN,
      ROLES.ROLE_VIEW_CONFIG_MODULE,
      ROLES.ROLE_EDIT_CONFIG_MODULE,
      ROLES.ROLE_ROLLBACK_CONFIG_MODULE,
    ],
  },
  {
    title: 'Cache reload Module',
    icon: <RefreshIcon />,
    path: LEGACY_CACHE_RELOAD_LIST_ROUTE,
    roles: [ROLES.ROLE_LEGACY_ADMIN, ROLES.ROLE_CACHE_RELOAD_MODULE],
  },
];

export default function LegacyPaymentOptions() {
  const permissions = useSelector(selectUserPermissions);
  const userRoles = useSelector(selectUserRoles);
  const firstRoute = getFirstRoute(userRoles, tabs);

  return (
    <ApplicationTemplate menu={tabs}>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to={firstRoute}
              replace
            />
          }
        />
        <Route
          path="/maintenance-schedule"
          exact
          element={<LegacyMaintenanceScheduleList permissions={permissions} />}
        />
        <Route
          path="/maintenance-schedule/new"
          exact
          element={<LegacyMaintenanceScheduleForm permissions={permissions} />}
        />
        <Route
          path="/contextual-messages"
          exact
          element={<LegacyContextualMessagesList />}
        />
        <Route
          path="/contextual-messages/new"
          exact
          element={<LegacyContextualMessagesForm />}
        />
        <Route
          path="/contextual-messages/:id"
          exact
          element={<LegacyContextualMessagesForm />}
        />
        <Route
          path="/configuration-module"
          exact
          element={<LegacyConfigurationList permissions={permissions} />}
        />
        <Route
          path="/configuration-module/:filePath"
          exact
          element={<LegacyConfigurationForm permissions={permissions} />}
        />
        <Route
          path="/cache-reload-module"
          exact
          element={<LegacyCacheReloadList permissions={permissions} />}
        />
      </Routes>
    </ApplicationTemplate>
  );
}
